import React from 'react';
export default class EditIcon extends React.Component {
  constructor(props) {
    super(props);
  }

  onClick(event) {
    if (this.props.onClick) this.props.onClick(event);
  }

  render() {
    var cls = 'content-edit-icon';
    if (this.props.cls) cls += ' ' + this.props.cls;

    if (this.props.active) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: cls,
        onClick: this.onClick.bind(this),
        style: this.props.style
      }, /*#__PURE__*/React.createElement("i", {
        className: "material-icons"
      }, "create")), this.props.children);
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "hide"
      });
    }
  }

}